function setDynamicHeight() {
  document.querySelectorAll('.section-adapt .adapt').forEach((photoMedia) => {
    let wrapper = photoMedia.closest('.adapt-wrapper'),
      aspectRatio = Number(wrapper.dataset.aspect),
      wrapperHeight = wrapper.offsetWidth / aspectRatio;
    wrapper.style.height = wrapperHeight + 'px';
  });
}
function scrollLoop() {
  (document.querySelectorAll('.parallax__section').forEach((section) => {
    let rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom >= 0) {
      let yScrollPosition = rect.top * 0.2 - 200,
        mediaElements = section.querySelectorAll('.photo__media'),
        widget = section.querySelector('.product-background__widget');
      mediaElements.forEach((image) => {
        (setTranslate(0, yScrollPosition, image),
          widget &&
            (window.innerWidth < 1200
              ? setTranslate(0, -yScrollPosition - 80, widget)
              : window.innerWidth < 1500
                ? setTranslate(0, -yScrollPosition - 100, widget)
                : setTranslate(0, -yScrollPosition - 50, widget)));
      });
    }
  }),
    requestAnimationFrame(scrollLoop));
}
function setTranslate(xPos, yPos, el) {
  el.classList.contains('product-background__widget')
    ? el.classList.contains('right')
      ? (el.style.transform = `translate(50%,-50%) translate(${xPos}px, ${yPos}px)`)
      : (el.style.transform = `translate(-50%,-50%) translate(${xPos}px, ${yPos}px)`)
    : (el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`);
}
(window.addEventListener('DOMContentLoaded', () => {
  (setDynamicHeight(), scrollLoop());
}),
  window.addEventListener('resize', () => {
    setDynamicHeight();
  }),
  Shopify.designMode &&
    (document.addEventListener('shopify:section:load', (event) => {
      setDynamicHeight();
    }),
    document.addEventListener('shopify:section:reorder', () => {
      setDynamicHeight();
    })));
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/parallax.js.map?v=1723521175
